var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSkinSocket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error_skin_socket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error_skin_socket",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#F03F3F",
    transform: "translate(50.000000, 50.000000) rotate(-270.000000) translate(-50.000000, -50.000000) ",
    x: 19,
    y: 2.5,
    width: 62,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(37.000000, 39.500000)",
    stroke: "#FFFFFF",
    strokeLinecap: "square",
    strokeOpacity: 0.563019012,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.625,
    y1: 0.35,
    x2: 0.375,
    y2: 6.65,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.625,
    y1: 0.35,
    x2: 20.375,
    y2: 6.65,
    id: "Line-Copy",
    transform: "translate(23.000000, 3.500000) scale(-1, 1) translate(-23.000000, -3.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 14.5,
    x2: 12.5,
    y2: 23.5,
    id: "Line-Copy-2",
    transform: "translate(12.500000, 19.000000) scale(-1, 1) translate(-12.500000, -19.000000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.876,57 L81.904,40.984 L81.904,31 L74.208,31 L74.208,40.984 L76.184,57 L79.876,57 Z M82.164,68.128 L82.164,60.12 L74,60.12 L74,68.128 L82.164,68.128 Z",
    id: "!",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSkinSocket);
export default __webpack_public_path__ + "static/media/error_skin_socket.593125d45a3904e7e55ba67a6241ec1c.svg";
export { ForwardRef as ReactComponent };